/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-dupe-class-members */
import React, { Component, useEffect, useRef } from "react";
import "./App.css";
import "./dark-theme.css";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import Dashboard from "./components/Pages/Dashboard";
import Login from "./components/Pages/Login";
import Pagenotfound from "./Pagenotfound";
import InitComponent from "./components/Pages/InitComponent";
import ls from "local-storage";
import { ThemeProvider as CustomThemeProvider, useTheme as useCustomTheme } from './ThemeContext';
import User from "./components/Pages/Users/Index";
import UserDetails from './components/Pages/Users/UserDetails';
import Permission from "./components/Pages/Permission";
import AuthApi from "./components/Services/Authapi";
import Role from "./components/Pages/Role";
import AddForm from "./components/Pages/Users/HandleUser";
import green from "@material-ui/core/colors/green";
// import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import Edittemplate from "./components/Pages/Documents/Edittemplate";
import EditUser from "./components/Pages/Users/EditUser";
import Leaves from "./components/Pages/Leaves/Leaves1";
import AddLeaves from "./components/Pages/Leaves/AddLeaves";
import EditLeaves from "./components/Pages/Leaves/EditLeaves";
import LeavesTicket from "./components/Pages/LeavesTicket/Ticket";
import AddTickets from "./components/Pages/LeavesTicket/AddTickets";
import EditTicket from "./components/Pages/LeavesTicket/EditTicket";
import ProtectedRoute from "./components/ProtectedRoute";
import Profile from "./components/Pages/Profile/Profile";
import Event from "./components/Pages/Event/Event";
import AddEvent from "./components/Pages/Event/AddEvent";
import EditEvent from "./components/Pages/Event/EditEvent";
import ShowEvent from "./components/Pages/ShowEvent/Show";
import Upcoming from "./components/Pages/UpcomingEvent/Upcoming";
import AddUpcomingEvent from "./components/Pages/UpcomingEvent/AddUpcomingEvent";
import EditUpcomingEvent from "./components/Pages/UpcomingEvent/EditUpcomingEvent";
import Job from "./components/Pages/JobPortal/JobList";
import Addjob from "./components/Pages/JobPortal/AddJob";
import Editjob from "./components/Pages/JobPortal/EditJob";
import Qulification from "./components/Pages/Qulification/QulificationList";
import Addqulification from "./components/Pages/Qulification/AddQulification";
import Editqulification from "./components/Pages/Qulification/EditQulification";
import Experience from "./components/Pages/Experience/ExperienceList";
import Addexperience from "./components/Pages/Experience/AddExperience";
import Editexp from "./components/Pages/Experience/EditExp";
import Time from "./components/Pages/Time_Entry/AddTime";
import Check from "./components/Pages/UserCheck/Check";
import Settings from "./components/Pages/Settings/Settings";
// import { capture } from "./ScreenShot";
import MailIcon from '@mui/icons-material/Mail';
import Cron from "./components/Pages/Cron/Cron";
import Offer from "./components/Pages/Documents/Offer";
import Latter from "./components/Pages/Documents/latter";
import Message from "./components/Pages/Messages/message";
import Header from "./components/Layouts/Header";
import Timer from "./components/Pages/TImer/timer";
import swal from "sweetalert";
import Roleadd from "./components/Pages/Roleadd";
import Testing from "./components/Pages/Testing/testing";
import OfferLatter from "./components/Pages/Documents/OfferLatter";
import Salaryslip from "./components/Pages/Documents/Salaryslip";
import Relievingletter from "./components/Pages/Documents/Relievingletter";
import Documentslist from "./components/Pages/Documents/Documentslist";
import OfferLatterAdd from "./components/Pages/Documents/OfferLatterAdd";
import Relievingletteradd from "./components/Pages/Documents/Relievingletteradd";
import Editrole from "./components/Pages/editrole";
import Forgotpassword from "./components/Layouts/Forms/AuthForms/Forgotpassword";
import Attendance from "./components/Pages/Attendance/Attendance";
import AuthCheckComponent from "./components/Layouts/Token";
import DetailedNotifications from "./components/Layouts/DetailedNotifications";
import listdesignation from "./components/Pages/Designation/listdesignation";
import Adddesignation from "./components/Pages/Designation/Adddesignation";
import editDesignation from "./components/Pages/Designation/editdesignation";
import Departmenteadd from "./components/Pages/Department/Departmentadd";
import Departmentedit from "./components/Pages/Department/Departmentedit";
import Departmentelist from "./components/Pages/Department/Departmentlist";
import Form360 from "./components/Pages/Feedback/Form360";
import Reviewformadd from "./components/Pages/Feedback/Reviewformadd";
import Reviewformlist from "./components/Pages/Feedback/Reviewformlist";
import Reviewformedit from "./components/Pages/Feedback/Reviewformedit";
import EmailTemplates from "./components/Pages/Documents/Emailtemplates";
import AddEmailtemplate from "./components/Pages/Documents/AddEmailtemplate";
import EditEmailtemplate from "./components/Pages/Documents/EditEmailtemplate";
import CreateTask from "./components/Pages/Tasks/CreateTask";
import Taskslist from "./components/Pages/Tasks/Taskslist";
import EditTask from "./components/Pages/Tasks/EditTask";
import ProjectList from "./components/Pages/Project/ProjectList";
import AddProject from "./components/Pages/Project/AddProject";
import EditProject from "./components/Pages/Project/EditProject";
import ProjectDetail from "./components/Pages/Project/ProjectDetail";
import ChatPage from "./components/Pages/Chat/ChatPage";
import PermissionCheck from "./components/PermissionCheck";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


// import UserDetails from "./components/Pages/Users/UserDetails";

// import {workerTimer} from "./components/Pages/Worker/worker-timer";

let idleTime = 0;
let tabVisibility;
const IDLE_TIMEOUT_MINUTES = 20;
const AUTO_TIMER_SESSION_KEY = "ems_auto_timer_session_started_at";

// SuperAdminClockInNotifier component
function SuperAdminClockInNotifier() {
  console.log('SuperAdminClockInNotifier: mounted');
  const lastCheckRef = useRef(Math.floor(Date.now() / 1000));
  const notifiedUserDayRef = useRef(new Set());

  // Load saved notifications once on mount
  useEffect(() => {
    try {
      const saved = localStorage.getItem('notifiedClockIns');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed)) {
          notifiedUserDayRef.current = new Set(parsed);
          console.log('Loaded notified clock-ins from localStorage:', parsed.length);
        }
      }
    } catch (e) {
      console.warn('Failed to parse notifiedClockIns', e);
    }
  }, []);

  function formatTo12Hour(time24) {
    if (!time24) return '';
    const [hourStr, minute] = time24.split(':');
    let hour = parseInt(hourStr, 10);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12 || 12;
    return `${hour}:${minute} ${ampm}`;
  }

  useEffect(() => {
    console.log('SuperAdminClockInNotifier: useEffect triggered');
    const lsRoles = ls.get('roles');
    let isSuperAdmin = false;
    if (lsRoles) {
      if (typeof lsRoles === 'string') {
        isSuperAdmin = lsRoles === 'Super Admin';
      } else if (Array.isArray(lsRoles)) {
        isSuperAdmin = lsRoles.includes('Super Admin') ||
          (lsRoles.some && lsRoles.some(r => (r && (r.name === 'Super Admin' || r === 'Super Admin'))));
      }
    }
    if (!isSuperAdmin) {
      return;
    }

    let polling = true;
    const poll = async () => {
      if (!polling) return;
      try {
        const since = lastCheckRef.current;
        const res = await AuthApi.getRecentClockIns(since);

        if (!res || res.status === false) {
          return;
        }
        if (res && res.clockIns && res.clockIns.length > 0) {
          // Sync with localStorage to avoid duplicates across tabs
          let currentNotified = new Set();
          try {
            const saved = localStorage.getItem('notifiedClockIns');
            if (saved) {
              const parsed = JSON.parse(saved);
              if (Array.isArray(parsed)) currentNotified = new Set(parsed);
            }
          } catch (e) {
            console.warn('Failed to parse notifiedClockIns inside poll', e);
          }

          let updated = false;
          res.clockIns.forEach(clockIn => {
            // Updated key: include in_time so multiple clock-ins on the same day are unique events
            const userDayKey = `${clockIn.user_id}_${clockIn.in_date}_${clockIn.in_time}`;

            // Critical Check: Check against the FRESH list from LS
            if (!currentNotified.has(userDayKey)) {
              currentNotified.add(userDayKey);
              updated = true;

              // Only notify if the event is RECENT (e.g. within last 10 minutes)
              // This prevents old notifications from appearing on page reload
              const isRecent = (() => {
                try {
                  if (!clockIn.in_date || !clockIn.in_time) return false;

                  const dateStr = `${clockIn.in_date}T${clockIn.in_time}`;
                  const eventTime = new Date(dateStr).getTime();
                  if (isNaN(eventTime)) {
                    console.warn('Skipping notification: Invalid date format:', dateStr);
                    return false; // Default to FALSE to prevent spam
                  }

                  const diff = Date.now() - eventTime;
                  const minutesDiff = diff / 1000 / 60;
                  console.log(`Clock-In Time Check: ${dateStr} | Age: ${minutesDiff.toFixed(2)} mins`);

                  // Check if event is within the last 2 minutes
                  // We enforce a strict window to prevent old notifications on reload/login
                  // We allows small negative values (future) for clock skew
                  const isFresh = diff < 2 * 60 * 1000 && diff > -5 * 60 * 1000;
                  if (!isFresh) {
                    console.log('Skipping old/future clock-in (outside 2min window):', dateStr);
                  }
                  return isFresh;
                } catch (e) {
                  console.error('Time check error:', e);
                  return false;
                }
              })();

              if (isRecent) {
                console.log('Dispatching Notification for:', userDayKey);

                if (Notification.permission === 'default') {
                  Notification.requestPermission();
                }
                if (Notification.permission === 'granted') {
                  new Notification('Employee Clocked In', {
                    body: `${clockIn.firstName} clocked in at ${formatTo12Hour(clockIn.in_time)}`,
                    icon: '/logo.png',
                    tag: userDayKey // unique tag prevents duplicate visual notifications in some browsers
                  });
                }
              } else {
                // console.log('Skipping old clock-in notification:', userDayKey);
              }
            }
          });

          // Save to localStorage if we added new notifications
          if (updated) {
            localStorage.setItem('notifiedClockIns', JSON.stringify([...currentNotified]));
            notifiedUserDayRef.current = currentNotified;
          }
        }
        lastCheckRef.current = res.serverTime || Math.floor(Date.now() / 1000);
      } catch (err) {
        console.warn('Polling error:', err && err.message ? err.message : err);
      }
    };
    poll();
    const interval = setInterval(poll, 3000); // Poll every 3 seconds for instant feedback
    return () => { polling = false; clearInterval(interval); };
  }, []);
  return null;
}


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authToken:
        ls.get("authToken") &&
          ls.get("authToken") !== null &&
          ls.get("authToken") !== false &&
          ls.get("authToken") !== "false" &&
          ls.get("authToken") !== "null" &&
          ls.get("authToken") !== "undefined"
          ? ls.get("authToken")
          : false,
      roles:
        ls.get("roles") && ls.get("roles") !== null && ls.get("roles") !== false
          ? ls.get("roles")
          : false,
      user:
        ls.get("user") && ls.get("user") !== null && ls.get("user") !== false
          ? ls.get("user")
          : false,
      authUser: false,
      location: document.location.pathname,
      count: ls.get("count") ? ls.get("count") : 0,
      timerOn: ls.get("timerOn") ? ls.get("timerOn") : false,
      startTime: ls.get("startTime") ? ls.get("startTime") : 0,
      stopTime: ls.get("stopTime") ? ls.get("stopTime") : 0,
      startTimeStat: false,
    };

    this.countRef = React.createRef(null);
    this.setAutUser = this.setAutUser.bind(this);
    this.updateCounterOnload = this.updateCounterOnload.bind(this);
    this.startTimer = this.startTimer.bind(this);
    // this.stopTimer = this.stopTimer.bind(this);
    // this.handleOnClick = this.handleOnClick.bind(this);
  }


  saveStateToLocalStorage() {
    ls.set("startTime", this.state.startTime);
    ls.set("count", this.state.count);
    ls.set("timerOn", this.state.timerOn);
    ls.set("stopTime", this.state.stopTime);
  }

  componentDidMount() {
    window.addEventListener(
      "beforeunload",
      this.saveStateToLocalStorage.bind(this)
    );

    if (this.state.timerOn === true) {
      this.runCycle();
    }

    let item;
    let eventKey;
    const vis = (c) => {
      let self = this;
      const browserProps = {
        hidden: "visibilitychange",
        msHidden: "msvisibilitychange",
        webkitHidden: "webkitvisibilitychange",
        mozHidden: "mozvisibilitychange",
      };
      for (item in browserProps) {
        if (item in document) {
          eventKey = browserProps[item];
          break;
        }
      }
      if (c) {
        if (
          !self._init &&
          !(typeof document.addEventListener === "undefined")
        ) {
          document.addEventListener(eventKey, c);
          self._init = true;
          c();
        }
      }
      return !document[item];
    };
    vis(async () => {
      tabVisibility = vis() ? "Visible" : "Not visible";
      // console.log(tabVisibility);
    });

    setInterval(timerIncrement, 60000);
    document.addEventListener("mousemove", (e) => {
      idleTime = 0;
    });

    document.addEventListener("keypress", (e) => {
      idleTime = 0;
    });

    async function timerIncrement() {
      idleTime = idleTime + 1;
      const exceededIdleTimeout = idleTime > IDLE_TIMEOUT_MINUTES;
      if (!exceededIdleTimeout) {
        return;
      }

      const hasActiveTimerSession = Boolean(window.localStorage.getItem(AUTO_TIMER_SESSION_KEY));
      if (hasActiveTimerSession) {
        return;
      }

      if (tabVisibility === "Visible" || tabVisibility === "Not visible") {
        await AuthApi.logout();
        window.location.reload();
      }
    }

    if (
      (window.performance.navigation &&
        window.performance.navigation.type === 1) ||
      window.performance
        .getEntriesByType("navigation")
        .map((nav) => nav.type)
        .includes("reload")
    ) {
    } else {
      // Do not auto-logout on first load; this caused bounce loops
      // AuthApi.logout();
      this.getAuth();
      // window.location.reload();
      return true;
    }
  }

  componentWillUnmount() {
    window.removeEventListener(
      "beforeunload",
      this.saveStateToLocalStorage.bind(this)
    );
    if (this.timer) {
      clearInterval(this.timer);
    }
    // saves if component has a chance to unmount
    this.saveStateToLocalStorage();
  }

  runCycle() {
    this.timer = setInterval(async () => {
      const newCount = this.state.count + parseInt(1);
      this.setState({ count: newCount >= 0 ? newCount : 0 }, function (param) {
        // this.updateCounterOnload(newCount);
      });
      this.saveStateToLocalStorage();
    }, 1000);
  }

  async startTimer() {
    await AuthApi.inTime();
    this.setState({ timerOn: true }, function () {
      this.setState({ startTime: Date.now() - this.state.startTime });
      this.runCycle();
    });
  }

  // async stopTimer() {
  //   await AuthApi.outTime();
  //   this.setState({ timerOn: false }, function () {
  //     this.setState({ stopTime: Date.now() });
  //     clearInterval(this.timer);
  //   });
  //   this.saveStateToLocalStorage();
  // }

  updateCounterOnload(count) {
    this.setState({ count: count });
  }

  async getAuth() {
    let checkLogin = await AuthApi.checkAuth();
    // console.log(checkLogin)
    if (checkLogin && checkLogin.status !== false) {
      this.setAutUser({ authUser: checkLogin.data });
    } else {
      // ls.set("roles", false);
      ls.set("authToken", false);
      // ls.set("user", false);
      this.setAutUser({
        authUser: false,
        authToken: false,
        // roles: false,
        // user: false,
        // roles: false,
        // user: false,
      });
    }
  }
  // hardik(AuthApi) {
  //   AuthApi.outTime();
  // }

  setAutUser(authData) {
    // console.log(authData);
    this.setState(authData);
    // AuthApi.outTime();
    // window.history.pushState({}, undefined, "/dashboard");
  }

  hasValidAuthToken(authToken) {
    return Boolean(
      authToken &&
      authToken !== false &&
      authToken !== "false" &&
      authToken !== "null" &&
      authToken !== "undefined"
    );
  }

  getLoginRedirectPath() {
    try {
      const storedRoute = window.sessionStorage.getItem("postLogoutLoginRoute");
      return ["/login"].includes(storedRoute)
        ? storedRoute
        : "/login";
    } catch (error) {
      return "/login";
    }
  }

  componentWillMount() {
    this.getAuth();
  }

  render() {
    // const userpermissions = (this.state.user && Array.isArray(this.state.user.roles) && this.state.user.roles[0] && Array.isArray(this.state.user.roles[0].permissions))
    // ? this.state.user.roles[0].permissions.map(permissionObj => permissionObj.name)
    // : [];
    // console.log(userpermissions)
    // const authToken = false;
    const hasValidAuthToken = this.hasValidAuthToken(this.state.authToken);
    const loginRedirectPath = this.getLoginRedirectPath();

    return (
      <div className="App">
        <ToastContainer />

        <Router>
          <PermissionCheck />
          <Switch>

            <Route
              exact
              path="/dashboard"
              render={(props) => (
                hasValidAuthToken ? (
                  <Dashboard
                    {...props}
                    authUser={this.state.authUser}
                    authToken={this.state.authToken}
                    roles={this.state.roles}
                    user={this.state.user}
                    setAutUser={this.setAutUser}
                    count={this.state.count}
                    timerOn={this.state.timerOn}
                    // updateCounter={this.updateCounter}
                    updateCounterOnload={this.updateCounterOnload}
                    startTimer={this.startTimer}
                    // stopTimer={this.stopTimer}
                    startTime={this.state.startTime}
                    stopTime={this.state.stopTime}
                  />
                ) : (
                  <Redirect to={loginRedirectPath} />
                )
              )}
            />

            <Route
              exact
              path="/dashboard"
              render={(props) => (
                <Header
                  {...props}
                  authUser={this.state.authUser}
                  authToken={this.state.authToken}
                  roles={this.state.roles}
                  user={this.state.user}
                  setAutUser={this.setAutUser}
                  count={this.state.count}
                  timerOn={this.state.timerOn}
                  // updateCounter={this.updateCounter}
                  updateCounterOnload={this.updateCounterOnload}
                  startTimer={this.startTimer}
                  // stopTimer={this.stopTimer}
                  startTime={this.state.startTime}
                  stopTime={this.state.stopTime}
                />
              )}
            />
            {/* <Route
              exact
              path="/dashboard"
              render={(props) => (
                <AuthCheckComponent
                  {...props}
                  authUser={this.state.authUser}
                  authToken={this.state.authToken}
                  roles={this.state.roles}
                  user={this.state.user}
                  setAutUser={this.setAutUser}
                  count={this.state.count}
                  timerOn={this.state.timerOn}
                  // updateCounter={this.updateCounter}
                  updateCounterOnload={this.updateCounterOnload}
                  startTimer={this.startTimer}
                  // stopTimer={this.stopTimer}
                  startTime={this.state.startTime}
                  stopTime={this.state.stopTime}
                />
              )}
            /> */}
            <ProtectedRoute
              {...this.props}
              exact
              path="/permission"
              component={Permission}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/role"
              component={Role}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />


            <ProtectedRoute
              {...this.props}
              exact
              path="/role/add"
              component={Roleadd}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/users"
              component={User}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />


            <ProtectedRoute
              {...this.props}
              exact
              path="/users/add"
              component={AddForm}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/users/:userId"
              component={UserDetails}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/users/edit/:id"
              authUser={this.state.authUser}
              component={EditUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/holiday-leaves"
              component={Leaves}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/holiday-leaves/add"
              authUser={this.state.authUser}
              component={AddLeaves}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/holiday-leaves/edit/:id"
              authUser={this.state.authUser}
              component={EditLeaves}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/leave-tickets"
              component={LeavesTicket}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/leave-tickets/add"
              authUser={this.state.authUser}
              component={AddTickets}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/leave-tickets/edit/:id"
              authUser={this.state.authUser}
              component={EditTicket}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/profile"
              component={Profile}
              user={this.state.user}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/event"
              component={Event}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/form360"
              component={Form360}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/review-form-add"
              component={Reviewformadd}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/review-form-list"
              component={Reviewformlist}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/review-form-edit/:id"
              component={Reviewformedit}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/event/add"
              authUser={this.state.authUser}
              component={AddEvent}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/event/edit/:id"
              authUser={this.state.authUser}
              component={EditEvent}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/show/:id"
              component={ShowEvent}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/upcoming-event"
              component={Upcoming}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/upcoming-event/add"
              component={AddUpcomingEvent}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/upcoming-event/edit/:id"
              authUser={this.state.authUser}
              component={EditUpcomingEvent}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/job"
              component={Job}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/job/add"
              component={Addjob}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/job/edit/:id"
              authUser={this.state.authUser}
              component={Editjob}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/role/edit/:id"
              authUser={this.state.authUser}
              component={Editrole}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/qulification"
              component={Qulification}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/qulification/add"
              component={Addqulification}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/qulification/edit/:id"
              authUser={this.state.authUser}
              component={Editqulification}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />









            <ProtectedRoute
              {...this.props}
              exact
              path="/designation"
              component={listdesignation}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/designation/add"
              component={Adddesignation}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/designation/edit/:id"
              authUser={this.state.authUser}
              component={editDesignation}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/Departmente"
              component={Departmentelist}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/Departmente/add"
              component={Departmenteadd}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/Departmente/edit/:id"
              authUser={this.state.authUser}
              component={Departmentedit}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />














            <ProtectedRoute
              {...this.props}
              exact
              path="/experience"
              component={Experience}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/experience/add"
              component={Addexperience}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/experience/edit/:id"
              authUser={this.state.authUser}
              component={Editexp}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />




            {/* <ProtectedRoute
              {...this.props}
              exact
              path="/OfferLatter"
              component={OfferLatter}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            /> */}





            <ProtectedRoute
              {...this.props}
              exact
              path="/time-entries/add"
              component={Time}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            <ProtectedRoute
              {...this.props}
              exact
              path="/time-entries"
              component={Check}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/documents/documents-list"
              component={Documentslist}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/templates/add"
              component={Offer}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/templates/edit/:id"
              component={Edittemplate}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/templates"
              component={Latter}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/documents/offer-letter"
              component={OfferLatter}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/documents/salary-slip"
              component={Salaryslip}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              roles={this.state.roles}
              user={this.state.user}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/documents/relieving-letter"
              component={Relievingletter}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/documents/offer-latter-add"
              component={OfferLatterAdd}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/documents/relieving-letter-add"
              component={Relievingletteradd}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/message"
              component={Message}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/timer"
              component={Timer}
              user={this.state.user}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/testing"
              component={Testing}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />


            <ProtectedRoute
              {...this.props}
              exact
              path="/attendance"
              component={Attendance}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/settings"
              component={Settings}
              user={this.state.user}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/detailed-notifications"
              component={DetailedNotifications}
              user={this.state.user}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />
            {/* <ProtectedRoute
              {...this.props}
              exact
              path="/Cron"
              component={Cron}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            /> */}
            <ProtectedRoute
              {...this.props}
              exact
              path="/cron"
              component={Cron}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/chat"
              component={ChatPage}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/email-templates"
              component={EmailTemplates}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/add-email-template"
              component={AddEmailtemplate}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/edit-email-template/:id"
              component={EditEmailtemplate}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/tasks/add"
              component={CreateTask}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/task/edit/:id"
              authUser={this.state.authUser}
              component={EditTask}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/tasks"
              component={Taskslist}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/project"
              component={ProjectList}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/project/:id"
              component={ProjectDetail}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/project/add"
              component={AddProject}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />

            <ProtectedRoute
              {...this.props}
              exact
              path="/project/edit/:id"
              authUser={this.state.authUser}
              component={EditProject}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />



            <Route
              exact
              path="/"
              render={(props) => (
                <InitComponent
                  {...props}
                  authUser={this.state.authUser}
                  setAutUser={this.setAutUser}
                  authToken={this.state.authToken}
                />
              )}
            />
            <Route
              exact
              path="/login"
              render={(props) => (
                <Login
                  {...props}
                  // component={hardik}
                  authUser={this.state.authUser}
                  setAutUser={this.setAutUser}
                  authToken={this.state.authToken}
                />
              )}
            />

            <Route
              path="/Forgotpassword"
              render={(props) => (
                <Forgotpassword
                // {...props}
                // // component={hardik}
                // authUser={this.state.authUser}
                // setAutUser={this.setAutUser}
                // authToken={this.state.authToken}
                />
              )}
            />

            <Route path="*" exact={true} component={Pagenotfound} />
          </Switch>
          <div className="timer">
            {this.state.authToken === false ? "" : <Timer
              {...this.props}
              component={Timer}
              user={this.state.user}
              authUser={this.state.authUser}
              authToken={this.state.authToken}
              setAutUser={this.setAutUser}
            />}
          </div>
        </Router>
        {/* Super Admin clock-in notifier */}
        <SuperAdminClockInNotifier />
      </div>
    );

  }
}

function AppWithTheme() {
  const { darkMode } = useCustomTheme();

  useEffect(() => {
    const cancelButtonClass = "global-cancel-button";
    const selector = 'button, [role="button"], .swal-button';

    const tagCancelButtons = () => {
      document.querySelectorAll(selector).forEach((node) => {
        const text = (node.textContent || "").trim().replace(/\s+/g, " ");
        if (text === "Cancel") {
          node.classList.add(cancelButtonClass);
        }
      });
    };

    tagCancelButtons();

    const observer = new MutationObserver(() => {
      tagCancelButtons();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    return () => observer.disconnect();
  }, []);

  const theme = createTheme({
    palette: {
      type: darkMode ? 'dark' : 'light',
      primary: {
        main: "#1B6E95",
        light: "#1b6e9582",
        dark: "#1B6E95",
      },
      secondary: {
        main: green[500],
        light: green[100],
        dark: green[900],
        contrastText: green[600],
      },
    },
    typography: {
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      subtitle1: {
        fontSize: 12,
      },
      body1: {
        fontWeight: 500,
      },
      button: {
        fontStyle: "italic",
      },
      h2: {
        fontSize: "1.2rem",
        "@media (min-width:600px)": {
          fontSize: "1.5rem",
        },
        float: "left",
        padding: "1%",
        marginTop: "5px",
        fontWeight: "500",
        color: "#1B6E95",
      },
    },
  });

  const shellClassName = `app-shell ${darkMode ? 'app-shell--dark dark-theme' : 'app-shell--light'}`;

  return (
    <ThemeProvider theme={theme}>
      <div className={shellClassName}>
        <App />
      </div>
    </ThemeProvider>
  );
}

export default function CustomStyles() {
  return (
    <CustomThemeProvider>
      <AppWithTheme />
    </CustomThemeProvider>
  );
}
